export const SET_CONNECTED = 'SET_CONNECTED';
export const SET_TEST_MESSAGE = 'SET_TEST_MESSAGE';
export const SET_SOCKET_AUTHENTICATED = 'SET_SOCKET_AUTHENTICATED';
export const SET_RECONNECT_ATTEMPTS = 'SET_RECONNECT_ATTEMPTS';

export const SET_FEED_CONNECTED = 'SET_FEED_CONNECTED';
export const SET_FEED_TEST_MESSAGE = 'SET_FEED_TEST_MESSAGE';
export const SET_FEED_SOCKET_AUTHENTICATED = 'SET_FEED_SOCKET_AUTHENTICATED';
